import { css, SerializedStyles } from '@emotion/react';
import { IStyles } from '../../context/Styles';

export const galleryControllerStyles = (styles: IStyles): SerializedStyles => css`
`;
